import { Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import {
  canActivateDataSource,
  SimpleViewComponent,
  ViewsLocalStorageService,
} from '@core/views-legacy';
import { WrappedTableListGroupHeadingComponent } from '@core/views-ui';
import { dataSourceProviders, provideTableLayout, provideViewBaseRoute } from '@core/views-util';

import { statusUserColumn } from './columns/status-column';
import { UserTicketsDataSourceService } from './user-tickets-data-source.service';
import { assignedToUserColumn } from '../ask-tickets-view/columns/assigned-to/assigned-to-column';
import { requestNameUserColumn } from '../ask-tickets-view/columns/request-name-column';
import { submittedAtUserColumn } from '../ask-tickets-view/columns/submitted-at-column';
import { askColumnFieldMap } from '../ask-tickets-view/columns/types';

const DATASOURCE_ID = 'ask_tickets';

@Component({
  selector: 'tlc-user-requests-view',
  template: `
    @if (canActivate()) {
      <rt-simple-view
        viewId="ask_tickets:my"
        [selfScrollEnabled]="true"
        [hasControls]="false"
        forcedLayout="table"
        class="view"
      />
    }
  `,
  imports: [SimpleViewComponent],
  providers: [
    ViewsLocalStorageService,
    provideViewBaseRoute('/asks/list'),
    UserTicketsDataSourceService,
    dataSourceProviders(DATASOURCE_ID, {
      [DATASOURCE_ID]: UserTicketsDataSourceService,
    }),
    provideTableLayout({
      [DATASOURCE_ID]: {
        tableGroupHeader: WrappedTableListGroupHeadingComponent,
        columns: [
          requestNameUserColumn,
          submittedAtUserColumn,
          statusUserColumn,
          assignedToUserColumn,
        ],
        columnFieldMap: askColumnFieldMap,
      },
    }),
  ],
  styleUrls: [
    '../ask-tickets-view/view-table-overrides.less',
    './user-tickets-view.component.less',
  ],
})
export class TellentUserTicketsViewComponent {
  private readonly canActivateFn = canActivateDataSource();
  private readonly canActivate$ = this.canActivateFn();
  protected canActivate = toSignal(this.canActivate$);
}
